// MED-845: Shared copy used by the participant dashboard to communicate the
// "your coach hasn't connected their scheduling tool yet" state. Centralized so
// the pill text and the hover tooltip stay identical across all three surfaces:
//   - Action Items rows ("Awaiting Coach Schedule" pill in ActionItemsSection)
//   - 1:1 Coaching session rows ("Awaiting Coach Schedule" pill in OneOnOneSessionCard)
//   - Group Coaching check-in rows ("Needs Scheduling" pill in CheckinLineItem,
//     tooltip gated to the not-connected state per AC11)

export const AWAITING_COACH_SCHEDULE_LABEL = 'Awaiting Coach Schedule';

export const AWAITING_COACH_TOOLTIP_COPY =
  "Your coach hasn't connected their scheduling tool yet. You'll be able to book your session here once they do.";
